module.exports = __webpack_public_path__ + "4afbe3f9fdd860446491c8377daf7c78.svg";